import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  fetching: true,
  relatedReports: [],
  error: null,
  relatedReportsTags: []
}

const relatedReportsSlice = createSlice({
  name: 'relatedReports',
  initialState,
  reducers: {
    requestRelatedReports: (state, { payload }) => {
      state.fetching = true
      state.relatedReportsTags = payload
    },
    requestRelatedReportsSuccess: (state, { payload }) => {
      state.fetching = false
      state.relatedReports = payload
      state.relatedReportsTags = []
    },
    requestRelatedReportsFailed: state => {
      state.fetching = false
      state.relatedReports = []
      state.relatedReportsTags = []
      state.error = 'Something went wrong while trying to get related reports'
    }
  }
})

export const { actions, reducer } = relatedReportsSlice

export const {
  requestRelatedReports,
  requestRelatedReportsSuccess,
  requestRelatedReportsFailed
} = actions

export default reducer
